import { createSlice } from '@reduxjs/toolkit';
import type { UserState } from '@/types/user';
import { user } from './thunks';

const initialState: UserState = {
  studies: [],
  isLoading: false,
  error: null,
  lastCreatedUser: null,
  users: [],
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // clearError: state => {
    //   state.error = null;
    // },
  },
  extraReducers: builder => {
    builder
      // Login
      .addCase(user.getUserStudies.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(user.getUserStudies.fulfilled, (state, action) => {
        state.studies = [...action.payload];
        state.isLoading = false;
        state.error = null;
      })
      .addCase(user.getUserStudies.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      // CreateUser
      .addCase(user.createUser.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(user.createUser.fulfilled, (state, action) => {
        state.lastCreatedUser = action.payload;
        state.isLoading = false;
        state.error = null;
      })
      .addCase(user.createUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      // GetUser
      .addCase(user.getUsers.pending, state => {
        state.error = null;
      })
      .addCase(user.getUsers.fulfilled, (state, action) => {
        state.users = [...action.payload];
        state.error = null;
      })
      .addCase(user.getUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

// export const { clearError } = studiesSlice.actions;
export const userReducer = userSlice.reducer;
